import React, { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";
import { z } from "zod";

// Wave-17 Item 1.1 — the BuildingsList page (Add Building flow + the
// portfolio dashboard) lazy-loads; the wrapper is tiny.
const BuildingsList = lazy(() => import("@/pages/BuildingsList/Page"));

const Buildings = () => (
  <div className="flex flex-col w-full min-h-full">
    {/* BuildingsList page renders its own <h1>Buildings</h1>. */}
    <SiteHeader />
    <Suspense fallback={null}>
      <BuildingsList />
    </Suspense>
  </div>
);

const statusArray = z.preprocess((val) => {
  const normalize = (value: unknown) => {
    if (typeof value === "number") return value;
    if (typeof value === "string") {
      const numeric = Number(value);
      return Number.isNaN(numeric) ? value : numeric;
    }
    return value;
  };

  if (Array.isArray(val)) return val.map(normalize);
  if (typeof val === "string" || typeof val === "number") return [normalize(val)];
  return val; // let Zod yell
}, z.array(z.union([z.number(), z.string()])));

const searchSchema = z.object({
  search: z.string().optional(),
  portfolio: z.array(z.string()).optional(),
  ll97_status: statusArray.optional(),
  ll88_status: statusArray.optional(),
  ll97_article: z.array(z.string()).optional(),
  order_by: z.string().optional(),
  // Sprint 7 § D1 — when present and truthy, the page auto-opens the
  // AddBuildingDialog on mount. Used by the BuildingDetailHeader's
  // "Remove and re-add" hard-restart flow: after deleting the building,
  // we navigate here with `?add=1` so the user lands directly in the
  // search step with no extra clicks.
  add: z.union([z.literal("1"), z.boolean()]).optional(),
});

export const Route = createFileRoute("/buildings/")({
  component: Buildings,
  validateSearch: (s: any) => searchSchema.parse(s),
});
